
import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import * as moment from 'moment';
import * as Highcharts from "highcharts";
import { Options } from "highcharts";
import { chartdata } from "../class/chatdata";
import { ActivatedRoute,Router  } from '@angular/router';

@Component({
  selector: 'app-sms-recode',
  templateUrl: './sms-recode.component.html',
  styleUrls: ['./sms-recode.component.css']
})
export class SmsRecodeComponent implements OnInit {
    Highcharts: typeof Highcharts = Highcharts;

    constructor(public httpClient: HttpClient,
        private  route: ActivatedRoute,
        private router: Router,
    ){}

    ngOnInit(): void {

        if(this.route.snapshot.paramMap.get('act')){
            this.search_sms = this.route.snapshot.paramMap.get('act');
        }
        this.getNowMonthRange();
        this.init_time();
    }
    lineOptions: Options = chartdata.line;
    updateFlag:boolean=false;
    sort_model:string = 'desc';
    data:any=[];
    edit_data:any=[];
    loading:boolean=true;
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    time :any={};
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }
    menu_now:string = '1';
    now:string = '1';
    menu_list:menulist = [
        {id:'1',name:'簡訊數據列表'},
    ]

    search_project:any='2';
    search_sms:any='3';
    data_view_list_act = '1';
    days = 0;
    sms_point = 0;
    roundedAveragesms: number = 0; // 保存計算後的平均值
    roundedAverage: number = 0; // 保存計算後的平均值
    roundedAllAverage: number = 0; // 保存計算後的平均值
    openMonthdata = false;
    monthRange = '';
    chartTotal:any = 0;
    all_num:any = 0;

    sms_list:menulist = [
        {id:'2',name:'twilio'},
        {id:'3',name:'av8d'},
        {id:'4',name:'mitake'},
    ]

    project_list:menulist = [
        {id:'1',name:'youbuy'},
        {id:'2',name:'voxy'},
        {id:'5',name:'social'},
        {id:'8',name:'sport_lottery'},
    ]


    tcontent = [
        {title:'專案類型',content:'project_id',type:3},
        {title:'使用類型',content:'used_type',type:3},
        {title:'數量',content:'num',sort:'num',css:'min-width: 100px;'},
        {title:'建立時間',content:'target_date',sort:'target_date',css:'min-width: 100px;'},
        {title:'更新時間',content:'update_dt'},
    ];

    data_view_list:menulist=[
        {id:'1',name:'以日檢視'},
        {id:'2',name:'以月檢視'},
    ];

    sort_obj = {column:'target_date',sort:'0'}

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    calculateAverage(): void {
        // 計算並四捨五入
        this.roundedAverage = this.days > 0 ? Math.round(this.chartTotal / this.days) : 0;
        this.roundedAllAverage = this.days > 0 ? Math.round(this.all_num / this.days) : 0;
        this.roundedAveragesms  = this.roundedAllAverage > 0 ? Math.round(this.sms_point / this.roundedAllAverage) : 0;

    }

    getNowMonthRange(){
        // 获取当前日期
        var currentDate = new Date();

        // 获取当前月份的年份和月份
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth() + 1; // 注意月份是从0开始计数的，所以要加1

        // 计算上个月的年份和月份
        var lastMonthYear = currentMonth === 1 ? currentYear - 1 : currentYear;
        var lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;

        // 格式化日期字符串
        function formatMonth(year, month) {
            return year + '-' + (month < 10 ? '0' : '') + month;
        }

        // 获取上个月和这个月的月份范围
        var lastMonthRange = formatMonth(lastMonthYear, lastMonth) + '月 - ' + formatMonth(currentYear, currentMonth) + '月';

        this.monthRange = lastMonthRange;
    }


    logRange(event) {
        this.monthRange = event;
    };

    disable(){
        this.pageobj= {page:0,count:10,total_count:0};
    }

    default(){
        this.data = [];
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr =JSON.parse(JSON.stringify(this.pageobj));
    }

    onDateTyped(event: any) {
        const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
        if (!val) { return; }
        const parts = val.split(' - ');
        if (parts.length !== 2) { return; }
        let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
        let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
        if (!s.isValid() || !e.isValid()) { return; }
        if (s.isAfter(e)) { const t = s; s = e; e = t; }
        // 冪等：與目前範圍相同就不重複觸發（避免點選後 blur 又重查一次）
        if (this.time && this.time.start === s.format('YYYY-MM-DD') && this.time.end === e.format('YYYY-MM-DD')) { return; }
        this.disable();
        this.onRangeSelected(1, { startDate: s, endDate: e });
    }

    onRangeSelected(type,value: any) {
        this.pageobj= {page:0,count:10,total_count:0};
        if(value.startDate){
            this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
            this.init_list();
        }
    }

    closeMonth(){
        this.openMonthdata = false;
        this.init_list();
    }

    openMonth(){
        this.pageobj= {page:0,count:5,total_count:0};
        this.openMonthdata = true;
    }

    init_time(){

        this.time.minDate = moment().subtract(180, 'days')
        this.time.maxDate = moment().subtract(0, 'days')
        this.time.startDate = moment().subtract(7, 'days');
        this.time.endDate = moment().subtract(0, 'days');
        this.time.start = moment(this.time.startDate)
        this.time.end = moment(this.time.endDate)

        this.init_list();
    }


    init_list(){
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count:this.pageobj.count,
            sort:this.sort_model,
            search_project:this.search_project,
            search_sms:this.search_sms,
            now_range:this.time,
            dataact:this.data_view_list_act,
            month:this.monthRange,
            sort_obj:this.sort_obj,
        };
        this.httpClient.post<any>("/v1/data_analyze/get_sms_list.php",body).subscribe(res => {
            this.loading = false;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
            if(res.status){
                this.data = res.data;
                this.chartTotal = res.chartTotal;
                this.sms_point = res.sms_point;
                this.days = res.days;
                this.all_num = res.all_num;
                this.pageobj.total_count = res.total_count;
                this.draw_chat(res);
                this.calculateAverage();
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    draw_chat(data){

        let categories = data.categories;
        let series = data.series;
        this.lineOptions.title.text = '專案簡訊使用折線圖';
        this.lineOptions.xAxis = { categories: categories };
        this.lineOptions.series = series;
        this.updateFlag = true;

    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }



}
